export let sendEmail;

export function setEmail(email) {
    sendEmail = email.sendEmail;
}
